import { render, staticRenderFns } from "./UnsplashItem.vue?vue&type=template&id=47f2533a&"
import script from "./UnsplashItem.vue?vue&type=script&lang=js&"
export * from "./UnsplashItem.vue?vue&type=script&lang=js&"
import style0 from "./unsplash-item.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports